// ============================================================================
// Entity: Templates
// Key: templates
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	getCustomPagesListQueryKey,
	getQueuesListQueryKey,
	getRolesListQueryKey,
	getSkillsListQueryKey,
	getTeamsListQueryKey,
	getTemplatesDetailQueryKey,
	getTemplatesDetailQueryOptions,
	getTemplatesListQueryKey,
	getTemplatesListQueryOptions,
	getTemplatesRelationsCustomPagesAssignedQueryKey,
	getTemplatesRelationsCustomPagesAssignedQueryOptions,
	getTemplatesRelationsCustomPagesAvailableQueryKey,
	getTemplatesRelationsCustomPagesAvailableQueryOptions,
	getTemplatesRelationsQueuesAssignedQueryKey,
	getTemplatesRelationsQueuesAssignedQueryOptions,
	getTemplatesRelationsQueuesAvailableQueryKey,
	getTemplatesRelationsQueuesAvailableQueryOptions,
	getTemplatesRelationsRolesAssignedQueryKey,
	getTemplatesRelationsRolesAssignedQueryOptions,
	getTemplatesRelationsRolesAvailableQueryKey,
	getTemplatesRelationsRolesAvailableQueryOptions,
	getTemplatesRelationsSkillsAssignedQueryKey,
	getTemplatesRelationsSkillsAssignedQueryOptions,
	getTemplatesRelationsSkillsAvailableQueryKey,
	getTemplatesRelationsSkillsAvailableQueryOptions,
	getTemplatesRelationsTeamsAssignedQueryKey,
	getTemplatesRelationsTeamsAssignedQueryOptions,
	getTemplatesRelationsTeamsAvailableQueryKey,
	getTemplatesRelationsTeamsAvailableQueryOptions,
	getTemplatesSettingsContactLoadQueryKey,
	getTemplatesSettingsContactLoadQueryOptions,
	getTemplatesSettingsGeneralLoadQueryKey,
	getTemplatesSettingsGeneralLoadQueryOptions,
	getTemplatesSettingsLoginLoadQueryKey,
	getTemplatesSettingsLoginLoadQueryOptions,
	getTemplatesSettingsPhoneLoadQueryKey,
	getTemplatesSettingsPhoneLoadQueryOptions,
	getTemplatesSettingsRecordingLoadQueryKey,
	getTemplatesSettingsRecordingLoadQueryOptions,
	getTemplatesSettingsSetclipLoadQueryKey,
	getTemplatesSettingsSetclipLoadQueryOptions,
	templatesCreate,
	templatesDelete,
	templatesRelationsCustomPagesAssign,
	templatesRelationsCustomPagesUnassign,
	templatesRelationsQueuesAssign,
	templatesRelationsQueuesUnassign,
	templatesRelationsRolesAssign,
	templatesRelationsRolesUnassign,
	templatesRelationsSkillsAssign,
	templatesRelationsSkillsUnassign,
	templatesRelationsTeamsAssign,
	templatesRelationsTeamsUnassign,
	templatesSettingsContactReset,
	templatesSettingsContactUpdate,
	templatesSettingsGeneralReset,
	templatesSettingsGeneralUpdate,
	templatesSettingsLoginReset,
	templatesSettingsLoginUpdate,
	templatesSettingsPhoneReset,
	templatesSettingsPhoneUpdate,
	templatesSettingsRecordingReset,
	templatesSettingsRecordingUpdate,
	templatesSettingsSetclipReset,
	templatesSettingsSetclipUpdate,
	templatesUpdate,
} from '../api/backstage'
// #region Imports
import type {
	ContactSettingsDto,
	CreateOrUpdateContactSettingsRequest,
	CreateOrUpdateGeneralSettingsRequest,
	CreateOrUpdateLoginSettingsRequest,
	CreateOrUpdatePhoneSettingsRequest,
	CreateOrUpdateRecordingSettingsRequest,
	CreateOrUpdateSetClipSettingsRequest,
	CreateTemplateRequest,
	GeneralSettingsDto,
	LoginSettingsDto,
	PagedResultOfCustomPageDto,
	PagedResultOfQueueSummary,
	PagedResultOfRoleSummary,
	PagedResultOfSkillSummary,
	PagedResultOfTeamSummary,
	PagedResultOfTemplateCustomPageResponse,
	PagedResultOfTemplateQueueResponse,
	PagedResultOfTemplateRoleResponse,
	PagedResultOfTemplateSkillResponse,
	PagedResultOfTemplateSummary,
	PagedResultOfTemplateTeamResponse,
	PhoneSettingsDto,
	RecordingSettingsDto,
	SetClipSettingsDto,
	TemplateCustomPageResponse,
	TemplateDetails,
	TemplateQueueResponse,
	TemplateRoleResponse,
	TemplateSkillResponse,
	TemplateSummary,
	TemplateTeamResponse,
	UpdateTemplateRequest,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const templatesEntityEndpoints = {
	create: defineMutationEndpoint<
		TemplateSummary,
		CreateTemplateRequest,
		undefined
	>({
		key: 'templates.create',
		method: 'POST',
		path: '/admin/templates',
		mutationOptions: () => ({
			mutationFn: (variables: { data: CreateTemplateRequest }) =>
				templatesCreate(variables.data),
		}),
		invalidates: [(_context) => getTemplatesListQueryKey()],
	}),
	delete: defineMutationEndpoint<void, undefined, { templateId: number }>({
		key: 'templates.delete',
		method: 'DELETE',
		path: '/admin/templates/{templateId}',
		pathParams: ['templateId'] as const,
		mutationOptions: () => ({
			mutationFn: (variables: {
				templateId: number | string | null | undefined
			}) => templatesDelete(variables.templateId),
		}),
		invalidates: [(_context) => getTemplatesListQueryKey()],
	}),
	detail: defineQueryEndpoint<
		TemplateDetails,
		{ templateId: number },
		undefined
	>({
		key: 'templates.detail',
		method: 'GET',
		path: '/admin/templates/{templateId}',
		pathParams: ['templateId'] as const,
		queryKey: (args) =>
			getTemplatesDetailQueryKey(args?.pathParams?.templateId),
		queryOptions: (args) =>
			getTemplatesDetailQueryOptions(args?.pathParams?.templateId),
	}),
	list: defineQueryEndpoint<
		PagedResultOfTemplateSummary,
		undefined,
		ListQueryParams
	>({
		key: 'templates.list',
		method: 'GET',
		path: '/admin/templates',
		queryKey: (args) => getTemplatesListQueryKey(args?.queryParams),
		queryOptions: (args) => getTemplatesListQueryOptions(args?.queryParams),
	}),
	update: defineMutationEndpoint<
		TemplateSummary,
		UpdateTemplateRequest,
		{ templateId: number }
	>({
		key: 'templates.update',
		method: 'PUT',
		path: '/admin/templates/{templateId}',
		pathParams: ['templateId'] as const,
		mutationOptions: () => ({
			mutationFn: (variables: {
				templateId: number | string | null | undefined
				data: UpdateTemplateRequest
			}) => templatesUpdate(variables.templateId, variables.data),
		}),
		invalidates: [
			(_context) => getTemplatesListQueryKey(),
			(context) =>
				getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
		],
	}),
} as const
// #endregion

// #region Relations
// #region Relation: CustomPages
// Target Entity: customPages
const templatesCustomPagesRelation = {
	key: 'customPages',
	targetEntity: 'customPages',
	endpoints: {
		assign: defineMutationEndpoint<
			TemplateCustomPageResponse[],
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.customPages.assign',
			method: 'POST',
			path: '/admin/templates/{templateId}/custompages',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsCustomPagesAssign(
						variables.templateId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsCustomPagesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsCustomPagesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getCustomPagesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTemplateCustomPageResponse,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.customPages.assigned',
			method: 'GET',
			path: '/admin/templates/{templateId}/custompages',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsCustomPagesAssignedQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsCustomPagesAssignedQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfCustomPageDto,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.customPages.available',
			method: 'GET',
			path: '/admin/templates/{templateId}/assignable-custompages',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsCustomPagesAvailableQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsCustomPagesAvailableQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.customPages.unassign',
			method: 'DELETE',
			path: '/admin/templates/{templateId}/custompages',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsCustomPagesUnassign(
						variables.templateId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsCustomPagesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsCustomPagesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getCustomPagesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Queues
// Target Entity: queues
const templatesQueuesRelation = {
	key: 'queues',
	targetEntity: 'queues',
	endpoints: {
		assign: defineMutationEndpoint<
			TemplateQueueResponse[],
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.queues.assign',
			method: 'POST',
			path: '/admin/templates/{templateId}/queues',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsQueuesAssign(variables.templateId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTemplateQueueResponse,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.queues.assigned',
			method: 'GET',
			path: '/admin/templates/{templateId}/queues',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsQueuesAssignedQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsQueuesAssignedQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfQueueSummary,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.queues.available',
			method: 'GET',
			path: '/admin/templates/{templateId}/assignable-queues',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsQueuesAvailableQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsQueuesAvailableQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.queues.unassign',
			method: 'DELETE',
			path: '/admin/templates/{templateId}/queues',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsQueuesUnassign(
						variables.templateId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Roles
// Target Entity: roles
const templatesRolesRelation = {
	key: 'roles',
	targetEntity: 'roles',
	endpoints: {
		assign: defineMutationEndpoint<
			TemplateRoleResponse[],
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.roles.assign',
			method: 'POST',
			path: '/admin/templates/{templateId}/roles',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsRolesAssign(variables.templateId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsRolesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsRolesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getRolesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTemplateRoleResponse,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.roles.assigned',
			method: 'GET',
			path: '/admin/templates/{templateId}/roles',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsRolesAssignedQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsRolesAssignedQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfRoleSummary,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.roles.available',
			method: 'GET',
			path: '/admin/templates/{templateId}/assignable-roles',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsRolesAvailableQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsRolesAvailableQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.roles.unassign',
			method: 'DELETE',
			path: '/admin/templates/{templateId}/roles',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsRolesUnassign(variables.templateId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsRolesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsRolesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getRolesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Skills
// Target Entity: skills
const templatesSkillsRelation = {
	key: 'skills',
	targetEntity: 'skills',
	endpoints: {
		assign: defineMutationEndpoint<
			TemplateSkillResponse[],
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.skills.assign',
			method: 'POST',
			path: '/admin/templates/{templateId}/skills',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsSkillsAssign(variables.templateId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTemplateSkillResponse,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.skills.assigned',
			method: 'GET',
			path: '/admin/templates/{templateId}/skills',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsSkillsAssignedQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsSkillsAssignedQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfSkillSummary,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.skills.available',
			method: 'GET',
			path: '/admin/templates/{templateId}/assignable-skills',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsSkillsAvailableQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsSkillsAvailableQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.skills.unassign',
			method: 'DELETE',
			path: '/admin/templates/{templateId}/skills',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsSkillsUnassign(
						variables.templateId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Teams
// Target Entity: teams
const templatesTeamsRelation = {
	key: 'teams',
	targetEntity: 'teams',
	endpoints: {
		assign: defineMutationEndpoint<
			TemplateTeamResponse[],
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.teams.assign',
			method: 'POST',
			path: '/admin/templates/{templateId}/teams',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsTeamsAssign(variables.templateId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsTeamsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsTeamsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getTeamsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTemplateTeamResponse,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.teams.assigned',
			method: 'GET',
			path: '/admin/templates/{templateId}/teams',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsTeamsAssignedQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsTeamsAssignedQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfTeamSummary,
			{ templateId: number },
			ListQueryParams
		>({
			key: 'templates.relations.teams.available',
			method: 'GET',
			path: '/admin/templates/{templateId}/assignable-teams',
			pathParams: ['templateId'] as const,
			queryKey: (args) =>
				getTemplatesRelationsTeamsAvailableQueryKey(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTemplatesRelationsTeamsAvailableQueryOptions(
					args?.pathParams?.templateId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ templateId: number }
		>({
			key: 'templates.relations.teams.unassign',
			method: 'DELETE',
			path: '/admin/templates/{templateId}/teams',
			pathParams: ['templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					templateId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					templatesRelationsTeamsUnassign(variables.templateId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTemplatesRelationsTeamsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTemplatesRelationsTeamsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTemplatesListQueryKey(),
				(_context) => getTeamsListQueryKey(),
			],
		}),
	},
} as const
// #endregion
// #endregion

// #region Settings
const templatesSettings = {
	key: 'settings',
	defaultSection: 'contact',
	sections: {
		contact: {
			key: 'contact',
			endpoints: {
				load: defineQueryEndpoint<
					ContactSettingsDto,
					{ templateId: number },
					undefined
				>({
					key: 'templates.settings.contact.load',
					method: 'GET',
					path: '/admin/templates/{templateId}/settings/contact',
					pathParams: ['templateId'] as const,
					queryKey: (args) =>
						getTemplatesSettingsContactLoadQueryKey(
							args?.pathParams?.templateId,
						),
					queryOptions: (args) =>
						getTemplatesSettingsContactLoadQueryOptions(
							args?.pathParams?.templateId,
						),
				}),
				reset: defineMutationEndpoint<void, undefined, { templateId: number }>({
					key: 'templates.settings.contact.reset',
					method: 'DELETE',
					path: '/admin/templates/{templateId}/settings/contact',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
						}) => templatesSettingsContactReset(variables.templateId),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsContactLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					ContactSettingsDto,
					CreateOrUpdateContactSettingsRequest,
					{ templateId: number }
				>({
					key: 'templates.settings.contact.update',
					method: 'PUT',
					path: '/admin/templates/{templateId}/settings/contact',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
							data: CreateOrUpdateContactSettingsRequest
						}) =>
							templatesSettingsContactUpdate(
								variables.templateId,
								variables.data,
							),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsContactLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		general: {
			key: 'general',
			endpoints: {
				load: defineQueryEndpoint<
					GeneralSettingsDto,
					{ templateId: number },
					undefined
				>({
					key: 'templates.settings.general.load',
					method: 'GET',
					path: '/admin/templates/{templateId}/settings/general',
					pathParams: ['templateId'] as const,
					queryKey: (args) =>
						getTemplatesSettingsGeneralLoadQueryKey(
							args?.pathParams?.templateId,
						),
					queryOptions: (args) =>
						getTemplatesSettingsGeneralLoadQueryOptions(
							args?.pathParams?.templateId,
						),
				}),
				reset: defineMutationEndpoint<void, undefined, { templateId: number }>({
					key: 'templates.settings.general.reset',
					method: 'DELETE',
					path: '/admin/templates/{templateId}/settings/general',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
						}) => templatesSettingsGeneralReset(variables.templateId),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsGeneralLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					GeneralSettingsDto,
					CreateOrUpdateGeneralSettingsRequest,
					{ templateId: number }
				>({
					key: 'templates.settings.general.update',
					method: 'PUT',
					path: '/admin/templates/{templateId}/settings/general',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
							data: CreateOrUpdateGeneralSettingsRequest
						}) =>
							templatesSettingsGeneralUpdate(
								variables.templateId,
								variables.data,
							),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsGeneralLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		login: {
			key: 'login',
			endpoints: {
				load: defineQueryEndpoint<
					LoginSettingsDto,
					{ templateId: number },
					undefined
				>({
					key: 'templates.settings.login.load',
					method: 'GET',
					path: '/admin/templates/{templateId}/settings/login',
					pathParams: ['templateId'] as const,
					queryKey: (args) =>
						getTemplatesSettingsLoginLoadQueryKey(args?.pathParams?.templateId),
					queryOptions: (args) =>
						getTemplatesSettingsLoginLoadQueryOptions(
							args?.pathParams?.templateId,
						),
				}),
				reset: defineMutationEndpoint<void, undefined, { templateId: number }>({
					key: 'templates.settings.login.reset',
					method: 'DELETE',
					path: '/admin/templates/{templateId}/settings/login',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
						}) => templatesSettingsLoginReset(variables.templateId),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsLoginLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					LoginSettingsDto,
					CreateOrUpdateLoginSettingsRequest,
					{ templateId: number }
				>({
					key: 'templates.settings.login.update',
					method: 'PUT',
					path: '/admin/templates/{templateId}/settings/login',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
							data: CreateOrUpdateLoginSettingsRequest
						}) =>
							templatesSettingsLoginUpdate(
								variables.templateId,
								variables.data,
							),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsLoginLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		phone: {
			key: 'phone',
			endpoints: {
				load: defineQueryEndpoint<
					PhoneSettingsDto,
					{ templateId: number },
					undefined
				>({
					key: 'templates.settings.phone.load',
					method: 'GET',
					path: '/admin/templates/{templateId}/settings/phone',
					pathParams: ['templateId'] as const,
					queryKey: (args) =>
						getTemplatesSettingsPhoneLoadQueryKey(args?.pathParams?.templateId),
					queryOptions: (args) =>
						getTemplatesSettingsPhoneLoadQueryOptions(
							args?.pathParams?.templateId,
						),
				}),
				reset: defineMutationEndpoint<void, undefined, { templateId: number }>({
					key: 'templates.settings.phone.reset',
					method: 'DELETE',
					path: '/admin/templates/{templateId}/settings/phone',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
						}) => templatesSettingsPhoneReset(variables.templateId),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsPhoneLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					PhoneSettingsDto,
					CreateOrUpdatePhoneSettingsRequest,
					{ templateId: number }
				>({
					key: 'templates.settings.phone.update',
					method: 'PUT',
					path: '/admin/templates/{templateId}/settings/phone',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
							data: CreateOrUpdatePhoneSettingsRequest
						}) =>
							templatesSettingsPhoneUpdate(
								variables.templateId,
								variables.data,
							),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsPhoneLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		recording: {
			key: 'recording',
			endpoints: {
				load: defineQueryEndpoint<
					RecordingSettingsDto,
					{ templateId: number },
					undefined
				>({
					key: 'templates.settings.recording.load',
					method: 'GET',
					path: '/admin/templates/{templateId}/settings/recording',
					pathParams: ['templateId'] as const,
					queryKey: (args) =>
						getTemplatesSettingsRecordingLoadQueryKey(
							args?.pathParams?.templateId,
						),
					queryOptions: (args) =>
						getTemplatesSettingsRecordingLoadQueryOptions(
							args?.pathParams?.templateId,
						),
				}),
				reset: defineMutationEndpoint<void, undefined, { templateId: number }>({
					key: 'templates.settings.recording.reset',
					method: 'DELETE',
					path: '/admin/templates/{templateId}/settings/recording',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
						}) => templatesSettingsRecordingReset(variables.templateId),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsRecordingLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					RecordingSettingsDto,
					CreateOrUpdateRecordingSettingsRequest,
					{ templateId: number }
				>({
					key: 'templates.settings.recording.update',
					method: 'PUT',
					path: '/admin/templates/{templateId}/settings/recording',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
							data: CreateOrUpdateRecordingSettingsRequest
						}) =>
							templatesSettingsRecordingUpdate(
								variables.templateId,
								variables.data,
							),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsRecordingLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		setclip: {
			key: 'setclip',
			endpoints: {
				load: defineQueryEndpoint<
					SetClipSettingsDto,
					{ templateId: number },
					undefined
				>({
					key: 'templates.settings.setclip.load',
					method: 'GET',
					path: '/admin/templates/{templateId}/settings/setclip',
					pathParams: ['templateId'] as const,
					queryKey: (args) =>
						getTemplatesSettingsSetclipLoadQueryKey(
							args?.pathParams?.templateId,
						),
					queryOptions: (args) =>
						getTemplatesSettingsSetclipLoadQueryOptions(
							args?.pathParams?.templateId,
						),
				}),
				reset: defineMutationEndpoint<void, undefined, { templateId: number }>({
					key: 'templates.settings.setclip.reset',
					method: 'DELETE',
					path: '/admin/templates/{templateId}/settings/setclip',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
						}) => templatesSettingsSetclipReset(variables.templateId),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsSetclipLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					SetClipSettingsDto,
					CreateOrUpdateSetClipSettingsRequest,
					{ templateId: number }
				>({
					key: 'templates.settings.setclip.update',
					method: 'PUT',
					path: '/admin/templates/{templateId}/settings/setclip',
					pathParams: ['templateId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							templateId: number | string | null | undefined
							data: CreateOrUpdateSetClipSettingsRequest
						}) =>
							templatesSettingsSetclipUpdate(
								variables.templateId,
								variables.data,
							),
					}),
					invalidates: [
						(context) =>
							getTemplatesSettingsSetclipLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTemplatesListQueryKey(),
						(context) =>
							getTemplatesDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
	},
} as const
// #endregion

// #region Entity Config Export
export const templatesEntityConfig = {
	key: 'templates',
	kind: 'entity',
	entity: {
		idField: 'id',
		idParam: 'templateId',
		routePath: '/templates',
	},
	endpoints: templatesEntityEndpoints,
	relations: {
		customPages: templatesCustomPagesRelation,
		queues: templatesQueuesRelation,
		roles: templatesRolesRelation,
		skills: templatesSkillsRelation,
		teams: templatesTeamsRelation,
	},
	settings: templatesSettings,
} as const satisfies EntityConfig<'templates'>
// #endregion
